/* Load the existing session recorder after the initial page load. */
(() => {
  function loadRecorder() {
    if (document.querySelector('script[src*="static.hotjar.com/c/hotjar-6407249"]')) return;
    window.hj = window.hj || function () { (window.hj.q = window.hj.q || []).push(arguments); };
    window._hjSettings = { hjid: 6407249, hjsv: 6 };
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.hotjar.com/c/hotjar-6407249.js?sv=6';
    document.head.appendChild(script);
  }
  function schedule() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(loadRecorder, { timeout: 3000 });
    else window.setTimeout(loadRecorder, 1000);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
